import { Trans, useTranslation } from 'next-i18next/pages';

import { useFlavorFromRoute } from '@pflegia/ui/hooks/use-flavor-from-route';
import Button from '@pflegia/ui/shared/button';

interface PflegiaFriendsContentProps {
  referrer: string;
  onSubmit: () => void;
}

const PflegiaFriendsContent = ({ referrer, onSubmit }: PflegiaFriendsContentProps) => {
  const { sourceDomainName: domain } = useFlavorFromRoute();
  const { t } = useTranslation('landingPage', { keyPrefix: 'pflegiaFriends' });

  return (
    <div className='flex h-full flex-1 flex-col justify-center sm:w-auto md:flex-row md:items-end lg:pl-12'>
      <div className='flex h-full flex-col pb-8'>
        <div className='flex flex-col px-4 pb-4 pt-8'>
          <span className='pb-6 text-xl'>
            <Trans
              components={{
                handwriting: <span className='whitespace-nowrap font-handwriting text-2xl text-main-blue' />,
                blue: <span className='text-main-blue' />,
              }}
              values={{ referrer, domain }}
              i18nKey='header'
              t={t}
            />
          </span>

          <div className='pb-6 text-lg italic'>{t('note')}</div>
        </div>
        <Button className='w-full rounded-full' onClick={onSubmit}>
          {t('submit')}
        </Button>
      </div>
    </div>
  );
};

export default PflegiaFriendsContent;
